export const ALERT_TYPES = {
	UNWEIGHED_CONTAINERS: "unweighed_containers",
	INVALID_WEIGHT: "invalid_weight",
};

export const ALERT_TYPE_OPTIONS = [
	{
		label: "Contenedores no pesados",
		value: ALERT_TYPES.UNWEIGHED_CONTAINERS,
	},
	{
		label: "Peso inválido",
		value: ALERT_TYPES.INVALID_WEIGHT,
	},
];

export const ALERT_TYPE_LABELS = ALERT_TYPE_OPTIONS.reduce((labels, option) => {
	labels[option.value] = option.label;
	return labels;
}, {});
